/*
 * Copyright (c) 2020.
 * Simon
 */

import {SERVER_API_PLATFORMJK} from '../../constans/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";
import {
    HEAR_FANPAGE_ATTACH_FAILURE,
    HEAR_FANPAGE_ATTACH_REQUEST,
    HEAR_FANPAGE_ATTACH_SUCCESS
} from "../../types/index";

/**
 * HearFanpageAttachAction
 */
const HearFanpageAttachAction = (hearId, fanpageId, actor) => ({

    [RSAA]: {
        endpoint: () => {
            return `${SERVER_API_PLATFORMJK}/api/hears/${hearId}/pages/${fanpageId}`
        },
        method: "PUT",
        headers: (headers()),
        types: [
            HEAR_FANPAGE_ATTACH_REQUEST,
            {
                type: HEAR_FANPAGE_ATTACH_SUCCESS,
                payload: async (action, state, res) => {
                    let data = [];
                    await res.json().then((json) => {
                        data = json.data
                    });

                    return {
                        "code": 0,
                        "action_type": HEAR_FANPAGE_ATTACH_SUCCESS,
                        "actor": actor,
                        "data": data,
                    }
                }
            },
            {
                type: HEAR_FANPAGE_ATTACH_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                        console.log(json);
                    });

                    return {
                        "code": 1,
                        "action_type": HEAR_FANPAGE_ATTACH_FAILURE,
                        "actor": actor,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {HearFanpageAttachAction}

